/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';

export class Parametro {
   constructor() {
      this.parametro_id = uuidV4();
      this.dt_ult_cadastro_clientes = null;
   }
}
